module.exports = __webpack_public_path__ + "static/media/history2.512340fc.jpg";